<!-- 海报编辑页 -->
<template>
  <div @click="handleClickCanvas" @keyup.esc="handleKeyup" ref="editorPane">
    <div class="editor-main" :style="{transform: 'scale('+scale+')', width: projectData.width + 'px', height: projectData.height + 'px'}">
        <div class="page-preview-wrapper" ref="canvas-panel" id="canvas-panel" :style="getCommonStyle(activePage.commonStyle)">
          <div
                v-for="item in activePage.elements"
                :key="item.uuid"
                :uuid="item.uuid"
                :defaultStyle="item.commonStyle"
                :style="getCommonStyle({width: item.commonStyle.width, height: item.commonStyle.height, left: item.commonStyle.left,top: item.commonStyle.top,position: item.commonStyle.position})"
                >
            <component :style="getCommonStyle({...item.commonStyle, top: 0, left: 0})" :is="item.elName" class="element-on-edit-pane" v-bind="item.propsValue"/>
          </div>
        </div>
    </div>
    <div class="show-bottom-view">
      <div class="show-bottom-text">下载 面料展App ，获取更多商机</div>
      <div class="show-btns-view">
        <div class="show-down-btn" @click="download">下载App</div>
        <div class="show-bottom-open-app" @click="openApp">已有App立即打开</div>
      </div>
    </div>
    <van-overlay :show="show" @click="show = false">
      <div class="tip-pop-view">
        <img v-if="judgeClient() == 'iOS'" class="tip-pop" src="../../assets/ios_browser_tips.png" />
        <img v-if="judgeClient() == 'Android'" class="tip-pop" src="../../assets/android_browser_tips.png" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import {_qk_register_components_object} from '@/plugins/index'
import editShape from '@/components/edit-shape'
import utils from '../../utils/util'
import {mapState, mapGetters} from 'vuex'
export default {
  props: {
    // canvas画板缩放
    scale: {
      type: Number,
      default: 1
    }
  },
  // import引入的组件需要注入到对象中才能使用
  components: {
    // 批量注册qk组件
    ..._qk_register_components_object,
    // 画板组件
    [editShape.name]: editShape
  },
  data () {
    // 这里存放数据
    return {
      show: false,
      currentUUID: '',
      getCommonStyle: utils.getCommonStyle,
      editorPaneWidth: 0,
      // activePage: {"uuid":"22287945-af8c-4b88-958b-856f3d2c45c8","name":"","elements":[{"uuid":"e8aaa74c-b197-4389-8c6c-387ffaf89e4c","elName":"qk-image","animations":[],"commonStyle":{"position":"absolute","width":375,"height":535,"top":0,"left":0,"rotate":0,"paddingTop":0,"paddingLeft":0,"paddingRight":0,"paddingBottom":0,"marginTop":0,"marginLeft":0,"marginRight":0,"marginBottom":0,"borderWidth":0,"borderColor":"","borderStyle":"solid","borderRadius":0,"boxShadow":"","fontSize":16,"fontWeight":500,"lineHeight":1.4,"letterSpacing":0,"textAlign":"center","color":"#000000","backgroundColor":"","backgroundImage":"","backgroundSize":"cover","opacity":1,"zIndex":1},"events":[],"propsValue":{"imageSrc":"https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/poster/poster-1-bg.png"},"valueType":"String"},{"uuid":"f7a0ade9-c696-4161-b9da-998fec97ebdb","elName":"qk-image","animations":[],"commonStyle":{"position":"absolute","width":265,"height":49,"top":332,"left":20,"rotate":0,"paddingTop":0,"paddingLeft":0,"paddingRight":0,"paddingBottom":0,"marginTop":0,"marginLeft":0,"marginRight":0,"marginBottom":0,"borderWidth":0,"borderColor":"","borderStyle":"solid","borderRadius":0,"boxShadow":"","fontSize":16,"fontWeight":500,"lineHeight":1.4,"letterSpacing":0,"textAlign":"center","color":"#000000","backgroundColor":"","backgroundImage":"","backgroundSize":"cover","opacity":1,"zIndex":3},"events":[],"propsValue":{"imageSrc":"https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/poster/poster-label.png"},"valueType":"String"},{"uuid":"036fc319-e61e-49a2-ab2e-2369c400ad3f","elName":"qk-text","animations":[],"commonStyle":{"position":"absolute","width":263,"height":36,"top":339,"left":22,"rotate":0,"paddingTop":0,"paddingLeft":0,"paddingRight":0,"paddingBottom":0,"marginTop":0,"marginLeft":0,"marginRight":0,"marginBottom":0,"borderWidth":0,"borderColor":"","borderStyle":"solid","borderRadius":0,"boxShadow":"","fontSize":20,"fontWeight":500,"lineHeight":1.4,"letterSpacing":0,"textAlign":"center","color":"#6A3404","backgroundColor":"","backgroundImage":"","backgroundSize":"cover","opacity":1,"zIndex":4},"events":[],"propsValue":{"text":"点击编辑文字!!"},"edit":true,"valueType":"String"},{"uuid":"cd1b9960-48b7-4eb2-85c1-9c14bf76eb45","elName":"qk-image","animations":[],"commonStyle":{"position":"absolute","width":301,"height":301,"top":111,"left":58,"rotate":0,"paddingTop":0,"paddingLeft":0,"paddingRight":0,"paddingBottom":0,"marginTop":0,"marginLeft":0,"marginRight":0,"marginBottom":0,"borderWidth":0,"borderColor":"","borderStyle":"solid","borderRadius":0,"boxShadow":"","fontSize":16,"fontWeight":500,"lineHeight":1.4,"letterSpacing":0,"textAlign":"center","color":"#000000","backgroundColor":"","backgroundImage":"","backgroundSize":"cover","opacity":1,"zIndex":2},"events":[],"propsValue":{"imageSrc":"http://img.eastfair.com/app/sial/998c9a4b7e164bdba9dfd2716d5b0d21/photo/202004061441465515320.jpeg"},"edit":true,"valueType":"String"},{"uuid":"9e6d4eb7-2a90-4974-ab74-744e0f297630","elName":"qk-text","animations":[],"commonStyle":{"position":"absolute","width":156,"height":27,"top":41,"left":45,"rotate":0,"paddingTop":0,"paddingLeft":0,"paddingRight":0,"paddingBottom":0,"marginTop":0,"marginLeft":0,"marginRight":0,"marginBottom":0,"borderWidth":0,"borderColor":"","borderStyle":"solid","borderRadius":0,"boxShadow":"","fontSize":18,"fontWeight":500,"lineHeight":1.4,"letterSpacing":0,"textAlign":"left","color":"#FFFFFF","backgroundColor":"","backgroundImage":"","backgroundSize":"cover","opacity":1,"zIndex":5},"events":[],"propsValue":{"text":"面料"},"edit":true,"valueType":"String"}],"commonStyle":{"backgroundColor":"","backgroundImage":"","backgroundSize":"cover"}}
      activePage: {},
      dataSource: {}
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapState({
      projectData: state => state.editor.projectData,
      activeElementUUID: state => state.editor.activeElementUUID
    }),
    ...mapGetters([
      'currentPageIndex',
      'activeElementIndex',
      'activeElement'
    ]),
    getMenuOptionsPositionStyle(){
      let both = (this.editorPaneWidth - this.projectData.width * this.scale) / 2;
      let right = both < 60 ? 16 : both;
      return {
        right: right + 'px'
      }
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getData() {
      var params = {
        id: this.$route.query.id
      }
      this.$http.getPosterDetail(params).then(res => {
        var data = res.data;
        console.log(data);
        this.activePage = JSON.parse(data.content);
        this.dataSource = data;
        window.document.title = data.name;
      }).catch(error => {
        // Dialog({ message: error.data.message });
      })
    },
    download() {
      if (this.isWeixin()) {
        this.show = true;
        return;
      }
      window.open('http://zhxt.eastfair.com/79819764734');
    },
    openApp() {
      if (this.isWeixin()) {
        this.show = true;
        return;
      }
      var openUrl = '';
      var path = '';
      if (this.dataSource.subjectType == 'ACTOR') {
        // 展商
        path = 'ExhibitorDetail'
      }
      if (this.dataSource.subjectType == 'PRODUCT') {
        // 展品
        path = 'ExhibitDetail'
      }
      if (this.judgeClient() == 'iOS') {
        openUrl = 'ivisitormianliao://openApp?path=' + path;
      }
      if (this.judgeClient() == 'Android') {
        openUrl = 'ivisitormianliao://eastfair?path=' + path;
      }
      var params = {
        id: this.dataSource.contentId,
        subject: 'VISITOR'
      }
      openUrl = openUrl + '&params=' + JSON.stringify(params);
      window.location.href = openUrl;
    },
    /*判断客户端*/
    judgeClient() {
      let client = '';
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {  //判断iPhone|iPad|iPod|iOS
        client = 'iOS';
      } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
        client = 'Android';
      } else {
        client = 'PC';
      }
      return client;
    },
    isWeixin () { //判断是否是微信
      var ua = navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";
    },
    save() {
      alert(JSON.stringify(this.activePage));
      console.log(JSON.stringify(this.activePage));
    },
    /**
     * 元素被点击
     * @param uuid
     */
    handleElementClick(uuid) {
      this.currentUUID = uuid;
      this.$store.dispatch('setActiveElementUUID', uuid);
    },
    /**
     * 移动改变元素大小定位
     * @param pos 当pos有值表示移动中需要实时同步样式变化，pos为undefind时则表示移动结束，记一次历史纪录
     * 鼠标移动完成时才记入历史纪录
     */
    handleElementResize(pos) {
      console.log('pos:');
      console.log(pos);
      if (!pos) {
        this.$store.dispatch('addHistoryCache')
        return;
      }
      console.log('this.activeElementIndex:');
      console.log(this.activeElementIndex);
      var index = this.getElementIndex();
      console.log(index);
      this.activePage.elements[index].commonStyle.left = pos.left
      // 更新元素commonStyle
      this.activePage.elements[index].commonStyle = {
        ...pos
      }
    },
    getElementIndex() {
      console.log('currentUUID:');
      console.log(this.currentUUID);
      var index = this.activePage.elements.findIndex(v => {
        return v.uuid === this.currentUUID;
      });
      return index;
    },
    handleClickCanvas(e) {
      if (!e.target.classList.contains('element-on-edit-pane') && !e.target.classList.contains('menu-item-on-edit-panel')) {
        this.$store.dispatch('setActiveElementUUID', '');
      }
    },
    /**
     * 对元素进行操作命令
     */
    handleElementCommand(command) {
      this.$store.dispatch('elementCommand', command)
    },
    /**
     * 监听键盘事件
     * @param e
     */
    handleKeyup(e) {
      console.log(1111, e);
    },
    /**
     * 提供截屏作为项目主图
     */
    screenshots() {
      const el = document.querySelector('#canvas-panel')
      html2canvas(el, {
        width:375,
        height:667,
        proxy: '/htmltocanvas/corsproxy' // 设置跨域接口
      }).then(canvas => {
        let url=canvas.toDataURL("image/jpeg");
        this.$store.commit('updateCoverImage', url)
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getData();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    // this.editorPaneWidth = this.$refs.editorPane.offsetHeight;
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.editor-pane {
  height: 100vh;
  width: 100%;
  border: 1px solid #f5f5f5;
  border-width: 0 1px;
  background-image: linear-gradient(45deg, #f5f5f5 25%, transparent 0, transparent 75%, #f5f5f5 0), linear-gradient(45deg, #f5f5f5 25%, transparent 0, transparent 75%, #f5f5f5 0);
  background-position: 0 0, 13px 13px;
  background-size: 26px 26px;
  display: flex;
  justify-content: center;
}
.element-on-edit-pane {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.editor-pane-inner {
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: 20px;
}

.editor-main {
  border-radius: 3px;
  box-shadow: 0 3px 10px #dcdcdc;
  margin: 0px auto;
  position: relative;
  background: white;
  transform-origin: center top;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZAgMAAAC5h23wAAAAAXNSR0IB2cksfwAAAAlQTFRF9fX18PDwAAAABQ8/pgAAAAN0Uk5T/yIA41y2EwAAABhJREFUeJxjYIAC0VAQcGCQWgUCDUONBgDH8Fwzu33LswAAAABJRU5ErkJggg==");
}
.page-preview-wrapper {
  height: 100%;
  position: relative;
}
.show-bottom-view {
  height: 58px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  padding: 22px 0px;
  position: fixed;
  bottom: 0px;
  width: 100%;
  left: 0px;
}
.show-bottom-text {
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  margin-bottom: 12px;
}
.show-btns-view {
  text-align: center;
}
.show-down-btn {
  margin-right: 14px;
  display: inline-block;
  padding: 0px 21px;
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  background: #3385FF;
  border-radius: 15px;
}
.show-bottom-open-app {
  display: inline-block;
  padding: 0px 21px;
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  border-radius: 15px;
  border-width: 1px;
  border-color: #FFFFFF;
  border-style: solid;
}
.tip-pop-view {
  position: relative;
}
.tip-pop {
  position: absolute;
  width: 250px;
  right: 20px;
  top: 20px;
}
</style>